import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TIMES = ["12am", ".", ".", "3am", ".", ".", "6am", ".", ".", "9am", ".", ".", "12pm", ".", ".", "3pm", ".", ".", "6pm", ".", ".", "9pm", ".", ".",];
const getOpacity = (value, maxValue) => {
    if (!maxValue) {
        return 0;
    }
    const result = Number((value / maxValue).toFixed(2));
    return Number.isNaN(result) ? 0 : result;
};
export const TimeOfDayHeatmapColumn = ({ index, topValue, topMaxValue, bottomValue, bottomMaxValue, }) => (_jsx("div", { className: "col", children: _jsxs("div", { className: "d-flex flex-column mb-1", children: [_jsx("div", { className: "border-top border-bottom m-0 p-0", children: _jsx("div", { className: "bg-danger soft-light-overlay", style: {
                        height: "3rem",
                        opacity: getOpacity(topValue, topMaxValue),
                    } }) }), _jsx("span", { className: "p-0 px-md-0 py-md-1 d-none d-md-inline", style: { textAlign: "center" }, children: TIMES[index] }), _jsx("span", { className: "pb-2 d-md-none", style: { textAlign: "center" }, children: "." }), _jsx("div", { className: "border-top border-bottom", children: _jsx("div", { className: "bg-danger soft-light-overlay", style: {
                        height: "3rem",
                        opacity: getOpacity(bottomValue, bottomMaxValue),
                    } }) })] }) }));
